import { SettingConst } from '@faire/web-api--source/types';

/**
 * Enables the Irrelevance UX improvement XP for retailers. PRD: https://faire.link/uv3qq
 */
export const IRRELEVANCE_UX_241017 = 'IRRELEVANCE_UX_241017' as SettingConst<
  'IRRELEVANCE_UX_241017',
  boolean,
  'RETAILER' | 'VISITOR_WEB'
>;
